import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  undoWrapper: {
    // Fixed => centered in the VISIBLE window. The previous absolute+50% was
    // 50% of the sidebar's scrollable content, so in a short window the toast
    // landed wherever the content was scrolled to, not mid-screen. The sidebar
    // animates width only (no transforms), so fixed anchors to the viewport.
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 11,
    // Horizontals mirror the sidebar widths from this file's keyframes
    // (right-docked sidebar, 12px inner gutter).
    left: 'auto',
    right: '12px',
    width: '236px',
    [theme.breakpoints.up(2000)]: {
      width: '276px',
    },
    [theme.breakpoints.up(3000)]: {
      width: '356px',
    },
    [theme.breakpoints.down('md')]: {
      left: '12px',
      right: '12px',
      width: 'auto',
    },
    padding: '13px 12px 16px 12px',
    display: 'flex',
    gap: '8px',
    flexDirection: 'column',
    borderRadius: '12px',
    backgroundColor: '#28282A',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '16px',
  },
  infoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .info-text': {
      color: '#988BEE',
      cursor: 'pointer',
    },
  },
  info: {
    display: 'flex',
    gap: '8px',
    color: '#ECECEC',
    '& .info-icon': {
      svg: {
        width: '16px',
        height: '16px',
      },
    },
  },
  process: {
    '& .MuiLinearProgress-root': {
      borderRadius: '10px',
      backgroundColor: '#5E5E60',
    },
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#988BEE',
    },
  },
}));
